import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import CUDService from "../../services/CUDService";

export const initialState = {
    loadingDelete:false,
    statusDelete:'',
    loadingStore:false,
    statusStore:'',
    loadingUpload:false,
    statusUpload:'',
}

export const deleteData = createAsyncThunk('cud/delete',async (data, { rejectWithValue }) => {
    const {url,id, ...rest}=data;
    try {
        const payload = id ? {id, ...rest} : {...rest};
        const response = await CUDService.delete(localStorage.getItem(AUTH_TOKEN),url,payload)
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            message.success(response.message,3);
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const storeData = createAsyncThunk('cud/store',async (data, { rejectWithValue }) => {
    const {url,param}=data;
    try {
        const response = await CUDService.store(localStorage.getItem(AUTH_TOKEN),url,{param})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            if(response.data) {
                Object.keys(response.data).forEach((key) => {
                    // Display each error message inside `data` as a notification
                    message.error(`${key}: ${response.data[key]}`, 3);
                });

            }else{
                message.error(response.message || 'Error',3)
            }
        }else{
            message.success(response.message,3);
        }
        return response
    } catch (err) {
        if (err.response?.status === 400 && err.response?.data) {
            const errorResponse = err.response.data;
            if (errorResponse.data) {
                Object.entries(errorResponse.data).forEach(([key, errorMessage]) => {
                    message.error(`${errorMessage}`, 3);
                });
            } else {
                message.error(errorResponse.message || 'Error', 3);
            }
        } else {
            // Generic error message
            message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!', 3);
        }
    }
})

export const uploadAvatar = createAsyncThunk('cud/upload',async (data, { rejectWithValue }) => {
    const {url,foto}=data;
    const formData = new FormData();

    try {
        formData.append('foto', foto);

        const response = await CUDService.upload(localStorage.getItem(AUTH_TOKEN),url,formData)
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            if(response.data) {
                Object.keys(response.data).forEach((key) => {
                    // Display each error message inside `data` as a notification
                    message.error(`${key}: ${response.data[key]}`, 3);
                });

            }else{
                message.error(response.message || 'Error',3)
            }
        }
        return response
    } catch (err) {
        if (err.response?.status === 400 && err.response?.data) {
            const errorResponse = err.response.data;
            if (errorResponse.data) {
                Object.entries(errorResponse.data).forEach(([key, errorMessage]) => {
                    message.error(`${errorMessage}`, 3);
                });
            } else {
                message.error(errorResponse.message || 'Error', 3);
            }
        } else {
            // Generic error message
            message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!', 3);
        }
    }
})


export const cudSlice = createSlice({
    name: 'cud',
    initialState,
    reducers: {
        showLoadingStore: (state) => {
            state.loadingStore = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteData.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.statusDelete = action.payload.success
            })
            .addCase(deleteData.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(deleteData.rejected, (state, action) => {
                state.loadingDelete = false
                state.statusDelete = action.payload.success
            })
            .addCase(storeData.fulfilled, (state, action) => {
                state.loadingStore = false
                state.statusStore = action.payload.success
            })
            .addCase(storeData.pending, (state) => {
                state.loadingStore = true
            })
            .addCase(storeData.rejected, (state, action) => {
                state.loadingStore = false
                state.statusStore = action.payload.success
            })
            .addCase(uploadAvatar.fulfilled, (state, action) => {
                state.loadingUpload = false
                state.statusUpload = action.payload.success
            })
            .addCase(uploadAvatar.pending, (state) => {
                state.loadingUpload = true
            })
            .addCase(uploadAvatar.rejected, (state, action) => {
                state.loadingUpload = false
                state.statusUpload = action.payload.success
            })
    },
})

export const {
} = cudSlice.actions

export default cudSlice.reducer
